module.exports = __webpack_public_path__ + "img/overview.ab089af4.png";